export const settingsSubscribers = new Set();

export const openTournamentSettings = (tab) => {
    settingsSubscribers.forEach(cb => cb(tab));
};
